import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlogPageService {

constructor(private http: HttpClient) { }
 
  getData = () => {
    return this.http.get(environment.userApiUrl + 'api/admin/blogPage')
  }

  Add = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/blogPage', data)
  }

  Update = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/blogPage', data)
  }

  deleteBlog = (id: any) => {
    return this.http.delete(environment.userApiUrl + 'api/admin/blogPageById/' + id)
  }

}